import { render, staticRenderFns } from "./RingAuthorizationForm.vue?vue&type=template&id=13ce2f87&scoped=true&"
import script from "./RingAuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./RingAuthorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./RingAuthorizationForm.vue?vue&type=style&index=0&id=13ce2f87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce2f87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ce2f87')) {
      api.createRecord('13ce2f87', component.options)
    } else {
      api.reload('13ce2f87', component.options)
    }
    module.hot.accept("./RingAuthorizationForm.vue?vue&type=template&id=13ce2f87&scoped=true&", function () {
      api.rerender('13ce2f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/ring/RingAuthorizationForm.vue"
export default component.exports